import React from 'react';
import { EcoClub4Class2025 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub4Class2025/>;
};

export default AccountGeneralPage;